import { toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

var _chunkArray = function chunkArray(arr, size) {
  if (arr.length <= size) return [arr];
  return [arr.slice(0, size)].concat(_toConsumableArray(_chunkArray(arr.slice(size), size)));
};
var chunkArray = _chunkArray;

export { chunkArray as default };
//# sourceMappingURL=chunkArray.js.map
